import * as React from 'react';
import { ReactNode } from 'react';
import { cn } from 'src/shared/lib/utils';

type LabelProps = {
  htmlFor?: string;
  children: ReactNode;
  className?: string;
};

export function Label({ children, htmlFor, className }: LabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(
        'text-sm block font-normal text-typography-darkgrey group-focus-within:text-typography-black',
        className
      )}
    >
      {children}
    </label>
  );
}
